import React, { useRef } from 'react';

import TireWheelPackageStatusItem from './components/tire-wheel-package-status-item/tire-wheel-package-status-item';
import {
  PACKAGE_STATUS,
  STEP_TYPE
} from './tire-wheel-package-status-constants';

import {
  useCmsPageContentSlots,
  useTireWheelPackage
} from '../../shared/hooks/hooks';

import './tire-wheel-package-status.scss';

interface TireWheelPackageStatusInterface {
  onChangeProductInBundle?: () => void;
}

function TireWheelPackageStatus(props: TireWheelPackageStatusInterface) {
  const { onChangeProductInBundle } = props;
  const { completedPackageType, currentTireWheelPackageFlow } =
    useTireWheelPackage();
  const { getContentSlot } = useCmsPageContentSlots('fitment-messages');

  function getStatus(step) {
    if (!currentTireWheelPackageFlow) {
      return '';
    } else if (
      completedPackageType ||
      currentTireWheelPackageFlow.step > step
    ) {
      return PACKAGE_STATUS.COMPLETED;
    } else if (currentTireWheelPackageFlow?.step === step) {
      return PACKAGE_STATUS.IN_PROGRESS;
    } else {
      return PACKAGE_STATUS.NOT_STARTED;
    }
  }

  function getText(stepType) {
    const stepTexts = {
      [STEP_TYPE.TIRES]:
        getContentSlot('byo-package.choose-tires') || 'Choose Tires',
      [STEP_TYPE.WHEELS]:
        getContentSlot('byo-package.choose-wheels') || 'Choose Wheels',
      [STEP_TYPE.FINALIZE]:
        getContentSlot('byo-package.complete') || 'Package Completed'
    };

    return stepTexts[stepType];
  }

  const entryTypeRef = useRef(
    completedPackageType ?? currentTireWheelPackageFlow?.type
  );

  const firstStepType = entryTypeRef.current;
  const secondStepType =
    firstStepType === STEP_TYPE.TIRES ? STEP_TYPE.WHEELS : STEP_TYPE.TIRES;

  const steps = [
    {
      count: 1,
      status: getStatus(0),
      text: getText(firstStepType),
      type: firstStepType
    },
    {
      count: 2,
      status: getStatus(1),
      text: getText(secondStepType),
      type: secondStepType
    },
    {
      count: 3,
      status: getStatus(2),
      text: getText(STEP_TYPE.FINALIZE),
      type: STEP_TYPE.FINALIZE
    }
  ];

  return (
    <div className="tire-wheel-package-status" styleName="container">
      {steps.map(step => (
        <TireWheelPackageStatusItem
          count={step.count}
          key={step.type}
          onChangeProductInBundle={onChangeProductInBundle}
          status={step.status}
          text={step.text}
          type={step.type}
        />
      ))}
    </div>
  );
}

export default TireWheelPackageStatus;
